var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"process_box"},[_c('processHead',{staticClass:"process_head",attrs:{"nowId":_vm.nowId,"pageNum":_vm.pageNum},on:{"update:fromGrandchild":_vm.updateMes}}),_c('processBody',{ref:"processBodyRef",staticClass:"process_body",attrs:{"coilingList":_vm.coilingList}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }